import { lazy } from 'react';

export default lazy(() =>
  import(/* webpackChunkName: 'process_details_page' */ './DetailsPage'),
);
